module.exports = __webpack_public_path__ + "static/img/logo.f7d15e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Vcar_List/logo.png
// module id = Y+cu
// module chunks = 19